import React, { useState } from 'react';
import axios from 'axios';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const Signup = () => {
  const [user, setUser] = useState({
    first_name: '',
    last_name: '',
    username: '',
    email: '',
    password: '',
    department: '',
    role: 'employee',
  });

  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };


  const submitUser = (e) => {
    e.preventDefault();
    setError('');

    axios.post('http://localhost:5000/user', user)
      .then((res) => {
        console.log(res.data);
        navigate('/');
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.status === 409) {
            setError("Invalid! Username isn't available");
            setUser((prevUser) => ({ ...prevUser, username: '' }));
          } else {
            setError(err.response.data.message || 'An unexpected error occurred. Please try again.');
          }
        } else {
          setError('Unable to connect to the server. Please try again.');
        }
      });
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center vh-100"
      style={{ backgroundColor: 'rgb(248, 248, 248)' }}>
      <div className="card p-4" style={{ maxWidth: '400px', width: '100%' }}>
        <form onSubmit={submitUser}>
        <div className="mb-3">
  <div className="row">
    <div className="col-md-6">
      <label className="form-label">First Name:</label>
      <input
        type="text"
        name="first_name"
        onChange={(e) => setUser({ ...user, first_name: e.target.value })}
        className="form-control"
        placeholder="John"
        value={user.first_name}
        required
      />
    </div>
    <div className="col-md-6">
      <label className="form-label">Last Name:</label>
      <input
        type="text"
        name="last_name"
        onChange={(e) => setUser({ ...user, last_name: e.target.value })}
        className="form-control"
        placeholder="Doe"
        value={user.last_name}
        required
      />
        </div>
        </div>
        </div>
          <div className="mb-3">
            <label className="form-label">Username:</label>
            <input
              type="text"
              name="username"
              onChange={(e) => setUser({ ...user, username: e.target.value })}
              className="form-control"
              placeholder="John_23"
              value={user.username}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Email:</label>
            <input
              type="email"
              name="email"
              onChange={(e) => setUser({ ...user, email: e.target.value })}
              className="form-control"
              placeholder="John@3gmai.com"
              value={user.email}
              required
            />
          </div>
        <div className="mb-3">
        <label className="form-label">Password:</label>
      <div className="input-group">
      <input type={passwordVisible ? 'text' : 'password'}
      name="password"
      onChange={(e) => setUser({ ...user, password: e.target.value })}
      className="form-control"
      placeholder="Enter your password"
      value={user.password}
      required/>
    <button
      type="button"
      className="btn btn-outline-secondary"
      onClick={togglePasswordVisibility}
      style={{ borderLeft: 'none' }} >
            {passwordVisible ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>
    </div>
          <div className="mb-3">
            <label className="form-label">Department:</label>
            <select
              name="department"
              onChange={(e) => setUser({ ...user, department: e.target.value })}
              className="form-select"
              value={user.department}
              required>
              <option value="" disabled>Select your department</option>
              <option value="Development">Development</option>
              <option value="Quality Assurance">Quality Assurance</option>
              <option value="Human Resources">Human Resources</option>
              <option value="Marketing">Marketing</option>
              <option value="Finance">Finance</option>
              <option value="Teacher">Teacher</option>
            </select>
          </div>
          {error && <p className="text-danger">{error}</p>}
          <button
            type="submit"
            className="btn btn-primary w-100"
            style={{ backgroundColor: 'black', borderColor: 'black' }}>
            Submit
          </button>
          <p className="text-center mt-3">
            <a href="/" className="text-primary">
              Log in
            </a>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Signup;
